import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ContactManager = () => {
  const [contacts, setContacts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    type: 'telegram',
    label: '',
    url: '',
    order_index: 0,
    is_active: true
  });
  const [loading, setLoading] = useState(false);

  const typeOptions = [
    { value: 'telegram', label: 'Telegram' },
    { value: 'teams', label: 'Microsoft Teams' },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/contacts/admin', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setContacts(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');

      if (editingItem) {
        await axios.put(`/api/contacts/${editingItem.id}`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post('/api/contacts', formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      fetchData();
      resetForm();
    } catch (error) {
      console.error('Error saving contact:', error);
      alert('Kaydetme hatası: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu iletişim bilgisini silmek istediğinizden emin misiniz?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`/api/contacts/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchData();
    } catch (error) {
      console.error('Error deleting contact:', error);
      alert('Silme hatası');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      type: item.type,
      label: item.label || '',
      url: item.url,
      order_index: item.order_index,
      is_active: item.is_active
    });
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({
      type: 'telegram',
      label: '',
      url: '',
      order_index: 0,
      is_active: true
    });
    setEditingItem(null);
    setShowForm(false);
  };

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-gold/30">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gold">İletişim Yönetimi</h2>
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-4 py-2 rounded-lg transition-all duration-300 shadow-gold"
        >
          {showForm ? 'İptal' : '+ Yeni İletişim'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-navy-700 p-6 rounded-lg mb-6 space-y-4">
          <div>
            <label className="block text-white mb-2">İletişim Tipi *</label>
            <select
              value={formData.type}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              required
            >
              {typeOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-white mb-2">Etiket (Label)</label>
            <input
              type="text"
              value={formData.label}
              onChange={(e) => setFormData({ ...formData, label: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              placeholder="Örn: Resmi Telegram Kanalımız"
            />
            <p className="text-white/60 text-xs mt-1">Boş bırakılırsa varsayılan isim kullanılır</p>
          </div>

          <div>
            <label className="block text-white mb-2">URL *</label>
            <input
              type="url"
              value={formData.url}
              onChange={(e) => setFormData({ ...formData, url: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              placeholder="https://t.me/example veya https://teams.microsoft.com/..."
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2">Sıra</label>
            <input
              type="number"
              value={formData.order_index}
              onChange={(e) => setFormData({ ...formData, order_index: parseInt(e.target.value) })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
            />
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              className="w-4 h-4"
            />
            <label className="text-white">Aktif</label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-2 px-4 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50"
          >
            {loading ? 'Kaydediliyor...' : (editingItem ? 'Güncelle' : 'Ekle')}
          </button>
        </form>
      )}

      <div className="space-y-4">
        {contacts.map((contact) => (
          <div key={contact.id} className="bg-navy-700 p-4 rounded-lg flex items-center gap-4">
            <div className="flex-1">
              <h3 className="text-white font-bold">{contact.label || contact.type}</h3>
              <p className="text-white/60 text-sm">Tip: {contact.type}</p>
              <p className="text-white/60 text-sm">URL: {contact.url}</p>
              <p className="text-white/60 text-sm">Sıra: {contact.order_index} | Durum: {contact.is_active ? 'Aktif' : 'Pasif'}</p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => handleEdit(contact)}
                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
              >
                Düzenle
              </button>
              <button
                onClick={() => handleDelete(contact.id)}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
              >
                Sil
              </button>
            </div>
          </div>
        ))}

        {contacts.length === 0 && (
          <p className="text-center text-white/60 py-8">Henüz iletişim bilgisi eklenmedi</p>
        )}
      </div>
    </div>
  );
};

export default ContactManager;
